import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "detail",
    "toggle",
    "expandAll",
    "checkbox",
    "selectAll",
    "bulkToolbar",
    "selectionCount",
    "expandedCount"
  ]

  connect() {
    this.syncExpandedState()
    this.syncSelectionState()
  }

  toggle(event) {
    event.preventDefault()
    const button = event.currentTarget
    const detail = this.detailTargets.find((target) => target.id === button.getAttribute("aria-controls"))
    if (!detail) return

    this.setExpanded(button, detail, detail.hidden)
    this.syncExpandedState()
  }

  toggleAll(event) {
    event.preventDefault()
    const shouldExpand = this.detailTargets.some((detail) => detail.hidden)

    this.detailTargets.forEach((detail) => {
      const button = this.toggleTargets.find((toggle) => toggle.getAttribute("aria-controls") === detail.id)
      if (button) this.setExpanded(button, detail, shouldExpand)
    })

    this.syncExpandedState()
  }

  toggleSelection() {
    if (!this.hasSelectAllTarget) return
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = this.selectAllTarget.checked
    })
    this.syncSelectionState()
  }

  selectionChanged() {
    this.syncSelectionState()
  }

  setExpanded(button, detail, expanded) {
    detail.hidden = !expanded
    button.setAttribute("aria-expanded", expanded.toString())
    const row = button.closest("tr")
    if (row) row.classList.toggle("is-expanded", expanded)
  }

  syncExpandedState() {
    const expanded = this.detailTargets.filter((detail) => !detail.hidden).length

    if (this.hasExpandAllTarget) {
      const allExpanded = this.detailTargets.length > 0 && expanded === this.detailTargets.length
      this.expandAllTarget.setAttribute("aria-expanded", allExpanded.toString())
      this.expandAllTarget.querySelector("span").textContent = allExpanded ? "Tout réduire" : "Tout développer"
    }

    if (this.hasExpandedCountTarget) {
      this.expandedCountTarget.textContent = expanded > 0 ? ` · ${expanded} développé${expanded > 1 ? "s" : ""}` : ""
    }
  }

  syncSelectionState() {
    if (!this.hasCheckboxTarget) return
    const selected = this.checkboxTargets.filter((checkbox) => checkbox.checked).length

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = selected === this.checkboxTargets.length
      this.selectAllTarget.indeterminate = selected > 0 && selected < this.checkboxTargets.length
    }

    if (this.hasBulkToolbarTarget) this.bulkToolbarTarget.hidden = selected === 0
    if (this.hasSelectionCountTarget) this.selectionCountTarget.textContent = selected.toString()
  }
}
